import instance from "../config";

const abrirPdf = async (endpoint) => {
  const response = await instance.get(endpoint, { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 5000);
};

// Descarga el PDF sin abrirlo (ej. para enviarlo por WhatsApp)
const obtenerPdf = async (endpoint) => {
  const response = await instance.get(endpoint, { responseType: 'blob' });
  return new Blob([response.data], { type: 'application/pdf' });
};

 const abrirPdfVentasRapidas = (id) => abrirPdf(`/api/pdf/ventaR/${id}`);
  const abrirPdfVentas = (id) => abrirPdf(`/api/pdf/venta/${id}`);
  const abrirPdfAlquiler = (id) => abrirPdf(`/api/pdf/alquiler/${id}`);

const obtenerPdfVentasRapidas = (id) => obtenerPdf(`/api/pdf/ventaR/${id}`);
const obtenerPdfVentas = (id) => obtenerPdf(`/api/pdf/venta/${id}`);
const obtenerPdfAlquiler = (id) => obtenerPdf(`/api/pdf/alquiler/${id}`);

export{
    abrirPdfVentasRapidas,
    abrirPdfVentas,
    abrirPdfAlquiler,
    obtenerPdfVentasRapidas,
    obtenerPdfVentas,
    obtenerPdfAlquiler,
}